import React, { useState, createContext, useContext, useEffect } from "react";
import { User } from "./User";
import { whoami, logout } from "./AuthDAO";
import { LoginForm } from "./LoginForm";
import { Payload } from "../DAO";

let onAuthRequired: () => void = () => { };
export function checkAuth(payload: Payload): Payload {
   if (!payload?.success && payload.issues?.length && payload.issues[0].code === 'UNAUTHORIZED') {
      onAuthRequired();
   }
   return payload;
}

type Auth = {
   readonly user: User;
   readonly logout: () => Promise<void>;
};

const authContext = createContext<Auth>(null as never);

type Props = {
   children?: React.ReactNode;
};
const AuthProvider = ({ children }: Props): JSX.Element => {
   const [user, setUser] = useState<User>();

   useEffect(() => {
      // initialize
      whoami().catch(() => null as never).then(setUser);
      // When auth is required, clear user
      onAuthRequired = () => setUser(null as never);
   }, []);

   async function logUserOut(): Promise<void> {
      return logout().then(() => {
         setUser(null as never);
      });
   }

   return (
      user ?
         <authContext.Provider value={{ user, logout: logUserOut }}>{children}</authContext.Provider>
         :
         <LoginForm setUser={setUser} />
   );
};

const useAuth = (): Auth => {
   return useContext(authContext);
};

export { AuthProvider, useAuth, Auth }